
function Day23({content}) {

    window.document.body.style.backgroundColor = "#FFFCF9";
    window.document.body.style.color = "#16324f";

  return (
    <div className="day place-items-center content-center" id="daysix">
    
                <div className="m-10 p-4 text-4xl lg:text-5xl" >Türchen 23</div>
    <div className="text-xl content-center w-11/12 md:w-1/2 place-items-center">
    <div className="place-items-center w-11/12 lg:w-1/2">
    Die Fahrt zurück<br/><br/>
    <div className="pb-5">
      Reflektiert auf der Fahrt über euren Urlaub und schreibt auf, wofür ihr dankbar seid.<br/><br/>    
    </div>
      </div>
   </div>
    </div>

  );
}

export default Day23;